import { render, staticRenderFns } from "./EventoImagen.vue?vue&type=template&id=19e4103e&scoped=true"
import script from "./EventoImagen.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoImagen.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EventoImagen.vue?vue&type=style&index=0&id=19e4103e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4103e",
  null
  
)

export default component.exports